import type { CreatorEntity } from "shared/schema";
import { StateError } from "shelving";
import { useOptionalGroupContext } from "../group/GroupContext.js";
import { useOptionalProfileContext } from "../profile/ProfileContext.js";

/** `CreatorContext` merges `GroupContext` and `ProfileContext` into one. */
export function useCreatorContext(): CreatorEntity {
	const group = useOptionalGroupContext();
	const profile = useOptionalProfileContext();
	if (group) return `group:${group.id}`;
	if (profile) return `profile:${profile.id}`;
	throw new StateError("useCreatorContext() must be used inside <GroupContext> or <ProfileContext>");
}
